import useApi from "./useApiRequest";
import { useMutation } from "react-query";


export const CancelDocumento = ()  => {
    const api = useApi();

    const mutate = async (params) => {
        const data  = await api.put(`/administracion-inventario/cancelar-documento/${params.id}`, params.data, {
            dataType: "json",
            hasFormData: false,
            hasCustomUrl: false,
        });
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        cancelDocumentoMutation: mutation.mutate,
    };
}